import * as Types from '../../graphql/generated';

import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type WorkspaceForBoardQueryVariables = {
  idBoard: Types.Scalars['ID'];
};


export type WorkspaceForBoardQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'idOrganization'>
  )> }
);


export const WorkspaceForBoardDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceForBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]}]}}]}}]};

/**
 * __useWorkspaceForBoardQuery__
 *
 * To run a query within a React component, call `useWorkspaceForBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceForBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceForBoardQuery({
 *   variables: {
 *      idBoard: // value for 'idBoard'
 *   },
 * });
 */
export function useWorkspaceForBoardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkspaceForBoardQuery, WorkspaceForBoardQueryVariables>) {
        return ApolloReactHooks.useQuery<WorkspaceForBoardQuery, WorkspaceForBoardQueryVariables>(WorkspaceForBoardDocument, baseOptions);
      }
export function useWorkspaceForBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceForBoardQuery, WorkspaceForBoardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WorkspaceForBoardQuery, WorkspaceForBoardQueryVariables>(WorkspaceForBoardDocument, baseOptions);
        }
export type WorkspaceForBoardQueryHookResult = ReturnType<typeof useWorkspaceForBoardQuery>;
export type WorkspaceForBoardLazyQueryHookResult = ReturnType<typeof useWorkspaceForBoardLazyQuery>;
export type WorkspaceForBoardQueryResult = ApolloReactCommon.QueryResult<WorkspaceForBoardQuery, WorkspaceForBoardQueryVariables>;